import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderHandlerService {

  outgoingServicesCount = 0;

  private _loaderEventSource = new Subject<boolean>();
  handler$ = this._loaderEventSource.asObservable();
  
  constructor() { }
  toggleLoader(serviceFlag: number) {
    switch (serviceFlag) {
    case 0: this.outgoingServicesCount -= 1;
      if (this.outgoingServicesCount <= 0) {
        this.outgoingServicesCount = 0;
        this._loaderEventSource.next(false);
      }
      break;
    case 1:
      this.outgoingServicesCount += 1;
      this._loaderEventSource.next(true);
      break;
    }
  }
}
